import React, { memo, useCallback, useState } from "react";

import { Box } from "@chakra-ui/react";
import { useUpdateQueryParams } from "hooks/useUpdateQueryParams";
import { debounce } from "lodash";
import { useLocation, useSearchParams } from "react-router-dom";
import { SEARCH_DEBOUNCE_TIMER } from "utils/constants";

import { TableSearchInput } from "ui/table/table-search-input";

import { DEFAULT_EMPLOYEES_TABLE_PAGINATION_PARAMS } from "./const";

// import { IBusinessEmployeeTableHeaderCTAsProps } from "./types";

export const BusinessEmployeesTableHeaderCTAs = memo(
  (/* props: IBusinessEmployeeTableHeaderCTAsProps */) => {
    const updateQueryParams = useUpdateQueryParams();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const search = searchParams.get("search");
    const [searchQuery, setSearchQuery] = useState(search || "");

    const onBusinessEmployeesSearch = useCallback(
      debounce(async (value: string) => {
        if (value.trim() === "") {
          updateQueryParams({
            ...Object.fromEntries(new URLSearchParams(location.search)),
            search: null,
            page: String(DEFAULT_EMPLOYEES_TABLE_PAGINATION_PARAMS.page),
            limit: String(DEFAULT_EMPLOYEES_TABLE_PAGINATION_PARAMS.limit),
          });
          return;
        }

        updateQueryParams({
          ...Object.fromEntries(new URLSearchParams(location.search)),
          search: value,
          page: String(DEFAULT_EMPLOYEES_TABLE_PAGINATION_PARAMS.page),
          limit: String(DEFAULT_EMPLOYEES_TABLE_PAGINATION_PARAMS.limit),
        });
      }, SEARCH_DEBOUNCE_TIMER),
      [location]
    );

    const handleSearchQueryChange = (
      evt: React.ChangeEvent<HTMLInputElement>
    ) => {
      const { value } = evt.target;
      setSearchQuery(value);
      onBusinessEmployeesSearch(value);
    };

    return (
      <Box className="flex px-3 items-center justify-between h-[85px] gap-4">
        <TableSearchInput
          searchQuery={searchQuery}
          handleSearchQueryChange={handleSearchQueryChange}
        />
      </Box>
    );
  }
);
